/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { ChangeEvent, useEffect, useState } from 'react';
import { Form, FormControl, Button } from 'react-bootstrap';
import { ReactComponent as AddSectionIcon } from '../../assets/icons/addSection.svg';
import SectionComponent from './sectionComponent';
import ButtonFormComponent from './button/form';
import { getContentArrayValue, getParamsValue, setFocus } from './utils';
import { LoreeInteractiveEditorDashboardContentType } from '../editor/editorUtilityFunctions/lintEditorType';
import { useSelector } from 'react-redux';
import { ParentDataInterface } from '../../redux/parentDataSlice';

interface ComponentProps {
  handleTitleChange: (event: ChangeEvent<HTMLInputElement>) => void;
  alreadyExist: string | null;
  titleValue: string;
  errors: any;
  contentArr: any[];
  addPanelHandel: any;
  parameter: any;
  number: any;
  type: string;
  handleChange: any;
  handleTitle: any;
  id: string;
  editContentData: any;
  pathName: string;
  optionId: number;
  dndLayout: string;
  editorConfig: LoreeInteractiveEditorDashboardContentType;
}

const ComponentBody = (props: ComponentProps) => {
  const {
    handleTitleChange,
    alreadyExist,
    titleValue,
    errors,
    contentArr,
    addPanelHandel,
    parameter,
    number,
    type,
    handleChange,
    handleTitle,
    editContentData,
    id,
    pathName,
    optionId,
    dndLayout,
    editorConfig,
  } = props;
  const [isRendered, setIsRendered] = useState(false);
  const interactiveState = useSelector(
    (state: ParentDataInterface) => state.parentData.interactiveState,
  );
  const [isReadOnly] = useState(interactiveState === 'collaborative' && id ? true : false);

  useEffect(() => {
    if (!isRendered) {
      setFocus('input-form');
      setIsRendered(true);
    }
  }, [isRendered]);

  const addpanel = () => {
    const params = getParamsValue(type, dndLayout);
    const contentValue = getContentArrayValue(type, dndLayout, number, optionId);
    addPanelHandel({
      parameters: [...parameter, params],
      contentArr: [...contentArr, contentValue],
      num: number + 1,
      option_id: optionId + 2,
    });
    setFocus(`collapse${parameter.length + 1}`);
  };

  return (
    <div className='p-2 pb-4 form-body-wrapper' id='form-wrapper'>
      {(type === 'Button' || type === 'checklist') && (
        <ButtonFormComponent
          id={id}
          editContent={editContentData}
          pathName={pathName}
          elementType={type}
        />
      )}
      {type !== 'Button' && type !== 'checklist' && (
        <>
          <Form.Group id='input-form'>
            <Form.Label
              className='title'
              style={{ color: '#707070', font: 'Lexend', fontSize: '14px', fontWeight: 300 }}
            >
              Interactive Title *
            </Form.Label>
            <FormControl
              className='lint-custom-input'
              readOnly={isReadOnly}
              name='title'
              id='title-input'
              onChange={handleTitleChange}
              value={titleValue}
              autoComplete='off'
              style={{
                ...(isReadOnly ? { opacity: 0.6, cursor: 'not-allowed' } : {}),
              }}
            />
            {alreadyExist && <Form.Text className='text-danger'>{alreadyExist}</Form.Text>}
            {errors.title && <Form.Text className='text-danger'>{errors.title}</Form.Text>}
          </Form.Group>
          <SectionComponent
            errors={errors}
            number={number}
            type={type}
            handleChange={handleChange}
            handleTitle={handleTitle}
            editorConfig={editorConfig}
            titleValue={titleValue}
          />
          {contentArr.length < 100 && (
            <div key='addPanel' className='addpanel-div position-relative my-5'>
              <Button
                className='mt-3 addpanel-button position-absolute AddSection-btn'
                onClick={addpanel}
                size='sm'
                id='Add section'
              >
                Add Section
                <AddSectionIcon />
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ComponentBody;
